import { CommentaryList } from '../../commentaries/basketball/CommentaryList';
import { CommentaryEdit } from '../../commentaries/basketball/CommentaryEdit';
import { CommentaryCreate } from '../../commentaries/basketball/CommentaryCreate';

export default {
    list: CommentaryList,
    create: CommentaryCreate,
    edit: CommentaryEdit,
}